<template lang="html">

  <div class="contenedor-tarifas">

    <article class="tarifa-el -solar">

      <div class="nombre-tarifa container">
        <figure>1</figure>
        <h2>
          <span class="-purple">{{ $t('tarifasLuz.tarifas.hogar.solar["2.0Solar"].title') }}</span>
          <span class="-orange">{{ $t('tarifasLuz.tarifas.hogar.solar["2.0Solar"].subtitle') }}</span>
        </h2>
      </div>

      <div class="contenedor-intro-tarifa row-center inside-picture">
        <div class="textos container">
          <div class="contenedor-textos">
            <h3 class="-orange">{{ $t('tarifasLuz.tarifas.hogar.solar["2.0Solar"].claim') }}</h3>
            <h5 class="check">{{ $t('tarifasLuz.tarifas.hogar.solar["2.0Solar"].objetive1') }}</h5>
            <h5 class="check">{{ $t('tarifasLuz.tarifas.hogar.solar["2.0Solar"].objetive2') }}</h5>
            <h5 class="check">{{ $t('tarifasLuz.tarifas.hogar.solar["2.0Solar"].objetive4') }}</h5>
          </div>
        </div>

        <img src="/static/img/bg-luz-solar.webp" class="img-tarifa">

        <img src="/static/img/figuras-naranjas.svg" class="figuras-naranjas">

      </div>

      <div class="contenedor-boton" v-show="!showpreciosDHA">

        <a @click="showpreciosDHA = true" class="btn -degree">{{ $t('quieroEstaTarifa') }}</a>

      </div>

      <seleccion-precio-tarifa :how="'DHA'" :type="'solar'" :priceType="'fixed'"></seleccion-precio-tarifa>
      <div class="container datos-tarifa -excendentes">
        <h3 class="mb-50 mt-50">EL MEJOR PRECIO PARA TUS EXCEDENTES</h3>
        <div class="contenedor-pagos container ais row-center">
          <article class="pago-el -small">
            <div>
              <h3 class="-dark-orange">Si ya tienes tu instalación fotovoltaica</h3>
            </div>
            <div>
              <template>
                <h2 class="precio -big">TUS EXCEDENTES A</h2>
                <h4 class="precio-big"><strong>{{precios.excedentes_otros}}</strong><strong class="€">€</strong><span> / kWh</span></h4>
              </template>
              <a class="nota-precio">Condiciones</a>
            </div>
          </article>
          <article class="pago-el -small">
            <div>
              <h3 class="-dark-orange">Si haces la instalación con nosotros</h3>
            </div>
            <div>
              <template>
                <h2 class="precio -big">TUS EXCEDENTES A</h2>
                <h4 class="precio-big"><strong>{{precios.excedentes}}</strong><strong class="€">€</strong><span> / kWh</span></h4>
              </template>
              <a class="nota-precio">Condiciones</a>
            </div>
          </article>
        </div>
      </div>
      <router-link class="btn -degree mt-50" :to="$t('enlaces.calculo_autoconsumo') + '/empresa'">Simula tu
        instalación
      </router-link>
    </article>

  </div>

</template>

<script lang="js">

import seleccionPrecioTarifa from '@/components/parts/selector-precio-tarifa';

import { mapGetters } from 'vuex';

export default {
  name: 'tarifas-menos',
  data() {
    return {
        showpreciosDA: true,
        showpreciosDHA: true,
    }
  },
  components: {
    'seleccion-precio-tarifa': seleccionPrecioTarifa
  },
  computed: {
    ...mapGetters({
        horario: 'gethorario',
        precios : 'getPrecios'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/luz/tarifas-solar.vue